import React from 'react';
import PropTypes from 'prop-types';
import QueueItem from '../QueueItem/QueueItemMUI';
import LoginHeader from '../LoginHeader/LoginHeader';
import Spinner from '../Spinner/Spinner';

const Queue = ({ meetings, areMeetingsLoading }) => {
    return areMeetingsLoading ? <Spinner /> :
        <div className="grid-y medium-grid-frame grid-padding-x tx-kiosk__content">
            <LoginHeader
                title="Waiting List"
                rightContent={
                    <h2 className="tx-kiosk__hint">
                        {meetings.length === 1 ? '1 Person' : `${meetings.length} People`}
                    </h2>
                } />
            <div className="cell auto cell-block-container">
                <div className="tx-infinite-scroll__no-overflow-x cell auto cell-block-container cell-block-y">
                    <ul className="tx-infinite-scroll__meetings tx-student-list">
                        {meetings.map((meetingData, index) => <QueueItem key={meetingData.id} meetingData={meetingData} meetingIndex={index} />)}
                    </ul>
                </div>
            </div>
        </div>;
};

export default Queue;

Queue.propTypes = {
    areMeetingsLoading: PropTypes.bool,
    meetings: PropTypes.array,
};

Queue.defaultProps = {
    areMeetingsLoading: true,
    meetings: [],
};



// WEBPACK FOOTER //
// ./src/components/Queue/Queue.jsx